import { useState } from "react";
import { Panel } from "@/admin/ui";

const NAMES = { welcome: "Bienvenida", payment_failed: "Pago fallido", renewal: "Renovación" };

export default function EmailTemplates({ templates, onChange }) {
  const [key, setKey] = useState("welcome");
  const t = templates[key];
  const set = (k, v) => onChange({ ...templates, [key]: { ...t, [k]: v } });
  return (
    <Panel title="Plantillas de email" testid="admin-settings-templates">
      <div className="adm-row" style={{ marginBottom: "1rem", gap: ".4rem" }}>
        {Object.entries(NAMES).map(([k, l]) => (
          <button key={k} className={`adm-btn sm ${k === key ? "primary" : ""}`} onClick={() => setKey(k)} data-testid={`admin-template-tab-${k}`}>{l}</button>
        ))}
      </div>
      <div className="adm-field"><label className="adm-label">Asunto</label>
        <input className="adm-input" value={t.subject} onChange={(e) => set("subject", e.target.value)} maxLength={160} data-testid="admin-template-subject" /></div>
      <div className="adm-field"><label className="adm-label">Texto</label>
        <textarea className="adm-textarea" style={{ minHeight: 200 }} value={t.body} onChange={(e) => set("body", e.target.value)} maxLength={5000} data-testid="admin-template-body" />
        <div className="adm-help">Cada línea es un párrafo. Escribe {"{nombre}"} para incluir el nombre del alumno.</div></div>
    </Panel>
  );
}
